import { InjectionToken } from '@angular/core';

export const GIFT_CARD_MAINTENANCE_UNLEASH_KEY = 'rd_gift_card_maintenance';
export const GIFT_CARD_MAINTENANCE: InjectionToken<boolean> =
  new InjectionToken<boolean>('GIFT_CARD_MAINTENANCE');

export const CAMPAIGN_MAINTENANCE_UNLEASH_KEY = 'rd_campaign_maintenance';
export const CAMPAIGN_MAINTENANCE: InjectionToken<boolean> =
  new InjectionToken<boolean>('CAMPAIGN_MAINTENANCE');

export const OFFERS_MAINTENANCE_UNLEASH_KEY = 'rd_offers_maintenance';
export const OFFERS_MAINTENANCE: InjectionToken<boolean> =
  new InjectionToken<boolean>('OFFERS_MAINTENANCE');

export const MERCHANDISE_MAINTENANCE_UNLEASH_KEY = 'rd_merchandise_maintenance';
export const MERCHANDISE_MAINTENANCE: InjectionToken<boolean> =
  new InjectionToken<boolean>('MERCHANDISE_MAINTENANCE');

export const GC_MAINTENANCE_UNLEASH_KEY = 'al_fe_anz-gc-banner';
export const GC_MAINTENANCE: InjectionToken<boolean> =
  new InjectionToken<boolean>('GC_MAINTENANCE');

export const BENEFITS_MAINTENANCE_UNLEASH_KEY = 'rd_benefits_maintenance';
export const BENEFITS_MAINTENANCE: InjectionToken<boolean> =
  new InjectionToken<boolean>('BENEFITS_MAINTENANCE');

export const UBER_VOUCHER_UNLEASH_KEY = 'bnz-uber-voucher';
export const UBER_VOUCHER_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('UBER_VOUCHER_ENABLED', {
    factory: () => false,
  });
